import AudioManager from "../../Shared/AudioManager";
import Player from "../../Models/Player";
const i18n = require('LanguageData');

const {ccclass, property} = cc._decorator;

@ccclass
export default class XimaDetails extends cc.Component {
    @property(cc.SpriteFrame)
    sp1: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    sp2: cc.SpriteFrame = null;
    @property(cc.Node)
    item: cc.Node = null;
    @property(cc.Node)
    contentNode = null;
    @property(cc.ToggleContainer)
    toggleContainer:cc.ToggleContainer = null;
    data = null;

    onLoad () {
        console.log("===进入details onLoad");
        this.node.setScale(0.1);
        this.node.opacity = 50;
        this.contentNode.active = false;
    }

    start(){
        this.node.active = true;
        this.node.runAction(
            cc.sequence(
                cc.spawn(
                    cc.scaleTo(0.2, 1).easing(cc.easeSineOut()),
                    cc.fadeIn(0.2).easing(cc.easeSineOut())
                ),
                cc.callFunc(function () {
                    //this.toggleContainer.toggleItems[0].isChecked = true;
                    this.onToggleSelected(null,"5",false)
                }.bind(this))
            )
        )
    }

    onEnable () {
        console.log("===进入details start");

    }

    // onDisable(): void {
    //     this.node.opacity = 50;
    //     this.node.setScale(0.1);
    // }

    onBtnClick(event,param){
        AudioManager.playSound("close");
        if (param === "close"){
            AudioManager.playSound("close")
            this.node.destroy();
        }
    }


    /**
     * 0:
     gameTypeId: 5
     gameTypeName: "棋牌游戏"
     gameInfoLists: Array(9)
     0:
     washCodeMoney: 0
     gameName: "黑桃棋牌"
     gameWashCodeDml: 0
     washCodeProportion: 70
     id: 146
     platform: "HT"
     gameTypeId: 1
     detailId: ""
     percentId: ""
     __proto__: Object
     1: {washCodeMoney: 0, gameName: "乐游棋牌", gameWashCodeDml: 0, washCodeProportion: 30, id: 15, …}
     2: {washCodeMoney: 0, gameName: "龙游棋牌", gameWashCodeDml: 0, washCodeProportion: 70.1, id: 123, …}
     3: {washCodeMoney: 0, gameName: "天豪棋牌", gameWashCodeDml: 0, washCodeProportion: 75, id: 125, …}
     4: {washCodeMoney: 0, gameName: "开元棋牌", gameWashCodeDml: 0, washCodeProportion: 73, id: 13, …}
     5: {washCodeMoney: 0, gameName: "新世界棋牌", gameWashCodeDml: 0, washCodeProportion: 31, id: 24, …}
     6: {washCodeMoney: 0, gameName: "VG棋牌", gameWashCodeDml: 0, washCodeProportion: 44, id: 12, …}
     7: {washCodeMoney: 0, gameName: "JDB棋牌", gameWashCodeDml: 0, washCodeProportion: 70, id: 28, …}
     8: {washCodeMo
     * @param event
     * @param param
     */
    onToggleSelected(event,param,bPlay = true){
        bPlay && AudioManager.playSound("toggle")
        let type = parseInt(param);
        for (let i = 0;i < this.data.length;i++){
            let item = this.data[i];
            if (type === item.gameTypeId){
                let gameInfos = item.gameInfoLists;
                let children  = this.contentNode.children
                for (let j = 0;j < gameInfos.length;j++){
                    let gameInfo = gameInfos[j];
                    let content = null;
                    if (j < children.length){
                        content = children[j];
                    }else
                        content = cc.instantiate(this.item);
                    content.parent = this.contentNode;
                    content.active = true;
                    content.getChildByName("sprite").getComponent(cc.Sprite).spriteFrame = (j % 2 === 0 ? this.sp1 : this.sp2) ;
                    content.getChildByName("labName").getComponent(cc.Label).string = gameInfo.gameName;
                    content.getChildByName("labCode").getComponent(cc.Label).string = (Player.getPy("currencySymbol") ? Player.getPy("currencySymbol"): i18n.t("currency_symbol")) + gameInfo.gameWashCodeDml.toFixed(2);
                    content.getChildByName("labRat").getComponent(cc.Label).string = gameInfo.washCodeProportion.toFixed(2) + "%";
                    content.getChildByName("labMoney").getComponent(cc.Label).string = (Player.getPy("currencySymbol") ? Player.getPy("currencySymbol"): i18n.t("currency_symbol")) + gameInfo.washCodeMoney.toFixed(2);
                }
                //关闭多余的item
                if (children.length > gameInfos.length){
                    for (let k = gameInfos.length;k < children.length;k ++){
                        children[k].active = false;
                    }
                }
                this.contentNode.active = true;

                break;
            }
        }
        this.node.active = true;
    }
}
